/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { SystemUpgradeUploadModule } from '../system-upgrade-upload/system-upgrade-upload.modules';
import { UpgradeService } from '../upgrade.service';
import { UpgradeUploadModule } from '../upload/upgrade-upload.modules';
import { UpgradeUploadEntryComponent } from './upgrade-upload-entry.component';
@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CoreModule,
        FormsModule,
        SystemUpgradeUploadModule,
        UpgradeUploadModule,
    ],
    declarations: [
        UpgradeUploadEntryComponent,
    ],
    providers: [UpgradeService],
    exports: [UpgradeUploadEntryComponent],
})
export class UpgradeUploadEntryModule { }
